import "../../../../content/projects/boft/boft.css";
import * as React from 'react';
export default {
  React
};